import React from "react";
import { Checkbox, CheckboxProps } from "@emisgroup/ui-checkbox";

interface CustomCheckboxProps {
/**
 * Data test id for the current checkbox
 */
  dataTestId?: string;
  /**
   * Label that needs to be displayed for the current checkbox
   */
  labelText?: string;
}

type CheckProps = CheckboxProps & CustomCheckboxProps;

/**
 * Responsible for rendering the checkbox component
 * @returns checkbox element
 */
export const UICheckbox: React.FC<CheckProps> = (props: CheckProps) => {

  const {
    name,
    id,
    dataTestId,
    onChange,
    className,
    value,
    labelText,
    checked,
    disabled
  } = props;

  return (
    <Checkbox
      className={className}
      data-testid={dataTestId}
      name={name}
      value={value}
      onChange={onChange}
      id={id}
      checked={checked}
      disabled={disabled}
    >
      {labelText}
    </Checkbox>
  );
};
